import { Component } from '@angular/core';
import { Principal } from '../../../../../shared';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../../../../shared/user/model/user.model';
import { UserService } from '../../../../../site-admin/services/user.service';
import { ParamContext } from '../../../../../shared/service/param.context';

@Component({
    selector: 'jhi-choose-list-user-modal',
    templateUrl: './choose-list-user-modal.component.html'
})
export class ChooseListUserModalComponent {

    users: User[];
    selectedUser: string;
    constructor(
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
        private principal: Principal,
        private paramContext: ParamContext,
        private userService: UserService
    ) {
    }

    ngOnInit(): void {
        this.userService.filterUsers(this.paramContext.cropName, this.paramContext.programUUID).toPromise().then(async (response) => {
            const currentUser = await this.principal.getCurrentlyLoggedInUser();
            this.users = response.body;
            this.selectedUser = currentUser.id;
        });
    }

    continue() {
        const userMap = this.users.reduce((map, user) => {
            map[user.id] = user;
            return map;
        }, {} as Record<string, User>);

        this.activeModal.close(userMap[this.selectedUser]);
    }
    cancel(): void {
        this.activeModal.close();
    }
}
